<template>
  <Layout v-wechat-title="$store.state.meta.title || '壹心理'">
    <router-view v-if="routerState" />
  </Layout>
</template>

<script>
import Layout from 'component/layout'
// import PageGrayFilter from 'lib/component/PageGrayFilter/index'

export default {
  components: {
    Layout
  },
  // 同一页面强制刷新
  provide() {
    return {
      reloadRouteComp: this.reloadRouteComp
    }
  },
  data() {
    return {
      routerState: true
    }
  },
  created() {
    if (!this.$isServer) {
      // PageGrayFilter()
      this.$bridge.hasNotch().then(({ statusBarHeight }) => {
        try {
          window.localStorage.setItem('statusBarHeight', statusBarHeight)

          var link = document.createElement('style')
          var head = document.getElementsByTagName('head')[0]

          link.rel = 'stylesheet'
          link.type = 'text/css'
          link.id = 'statusBarHeight'
          head.appendChild(link)
          var len = document.styleSheets.length - 1
          document.styleSheets[len].addRule(
            '.common-basic-app-status-bar-padding-top',
            'padding-top: ' + statusBarHeight + 'px !important'
          )
        } catch (e) {
          console.log('设置statusbar height cache error', e)
        }
      })
    }
  },
  methods: {
    reloadRouteComp() {
      this.routerState = false
      this.$nextTick(() => (this.routerState = true))
    }
  }
}
</script>

<style lang="scss">
@import '~app/web/style/reset.scss';
@import '../../../node_modules/swiper/dist/css/swiper.min.css';
</style>
